import { Table, TableContainer, TableHead, TableRow, TableCell, TableBody, Dialog, Tabs, Tab, TextField, Box } from "@mui/material";
import moment from "moment";
import React, { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ButtonWithAPICall from "./../../commons/ButtonWithAPICall.component";
import { useCallback } from "react";
import { restorePI, updatePIStatus } from "../../../services/api";
import { statusColor } from "./../../config";
import EditPI from "./editPI";
import { useReactToPrint } from "react-to-print";
import { toHttpsURL } from "../../../services/libService";
const InvoiceXMLReader = React.memo(({ data, open, onClose, onResponse, onEditResponse }) => {
  const ref = useRef();
  const user = useSelector((state) => state.user.data);
  const [tab, setTab] = useState(2);
  const [t] = useTranslation();
  const [note, setNote] = useState("");
  const handlePrint = useReactToPrint({
    content: () => ref.current,
  });
  const handleAccept = useCallback(() => {
    return updatePIStatus(data?.id, {
      apv: true,
      note: note,
    });
  }, [data, note]);
  const handleDecline = useCallback(() => {
    return updatePIStatus(data?.id, {
      apv: false,
      note: note,
    });
  }, [data, note]);

  if (data)
    return (
      <Dialog open={open} onClose={onClose} fullWidth maxWidth={false}>
        <Box display="flex" justifyContent="center" width="100%" style={{ backgroundColor: "#b3deff", position: "sticky", top: 0 }}>
          <Tabs value={tab} onChange={(e, newValue) => setTab(newValue)}>
            <Tab value={2} label={t("Trạng thái hóa đơn")} />
            {data?.status === "CHECKING" && <Tab value={3} label={t("Chỉnh sửa hóa đơn")} />}
            <Tab value={1} label={t("File PDF")} />
          </Tabs>
        </Box>
        <div style={{ height: "1000px", padding: 10 }} hidden={tab === 1}>
          <div hidden={tab !== 2} ref={ref} style={{ padding: 30 }}>
            <div align="left" style={{ marginBottom: 0 }}>
              <b>{t("Trạng thái hóa đơn")}</b>:
            </div>
            <TableContainer style={{ marginBottom: 33 }}>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={1} align="left">
                      {t("Trạng thái hóa đơn")}:{" "}
                      <div className={`status ${data?.status}`} style={{ display: "inline-flex", color: statusColor[data?.status], marginRight: 20 }}>
                        {t(data?.status)}{" "}
                      </div>
                      {data.status === "DELETED" && user.organization_id === 1 && (
                        <ButtonWithAPICall color="success" variant="contained" size="small" api={() => restorePI(data.id)} response={onEditResponse}>
                          {t("Khôi phục")}
                        </ButtonWithAPICall>
                      )}
                    </TableCell>
                    <TableCell colSpan={1} align="left">
                      {t("Ngày upload hóa đơn")}: {data?.created_at && moment(data.created_at).format("DD/MM/YYYY")}
                    </TableCell>
                    <TableCell colSpan={1} align="left">
                      <div style={{}}>
                        <a href={toHttpsURL(data?.xml)} rel="noreferrer" target="_blank" download>
                          Tải XML
                        </a>
                        &nbsp;
                        <span className="link" onClick={handlePrint}>
                          In trang
                        </span>
                      </div>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell width="33%" align="left">
                      {t("Tổ chức")}: {data?.organization_name}
                    </TableCell>
                    <TableCell width="33%" align="left">
                      {t("Phòng/Ban")}: {data?.department_name}
                    </TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell width="33%" align="left">
                      {t("Người tạo")}: {data?.username}
                    </TableCell>
                    <TableCell width="33%" align="left">
                      {t("Ngày hóa đơn")}: {data?.date && moment(data?.date).format("DD/MM/YYYY")}
                    </TableCell>
                    <TableCell width="33%" align="left">
                      {t("Ghi chú")}: {data?.note}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell width="33%" align="left">
                      {t("Người kiểm tra")}: {data?.checker_name}
                    </TableCell>
                    <TableCell width="33%" align="left">
                      {t("Ngày kiểm tra")}: {data?.chk_date && moment(data.chk_date).format("DD/MM/YYYY")}
                    </TableCell>
                    <TableCell width="33%" align="left">
                      {t("Ghi chú")}: {data?.chk_note}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell width="33%" align="left">
                      {t("Người duyệt")}: {data?.approver_name}
                    </TableCell>
                    <TableCell width="33%" align="left">
                      {t("Ngày duyệt")}: {data?.apv_date && moment(data.apv_date).format("DD/MM/YYYY")}
                    </TableCell>
                    <TableCell width="33%" align="left">
                      {t("Ghi chú")}: {data?.apv_note}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>

            {["CHECKING", "CHECKED"].includes(data?.status) && (
              <React.Fragment>
                <TextField fullWidth label={t("Ghi chú")} value={note} onChange={(e) => setNote(e.target.value)} />
                <div style={{ display: "flex" }}>
                  <div style={{ margin: "10px 10px 10px 0" }}>
                    <ButtonWithAPICall variant="contained" api={handleAccept} response={onResponse}>
                      {t("Xác nhận")}
                    </ButtonWithAPICall>
                  </div>
                  <div style={{ margin: "10px 10px 10px 0" }}>
                    <ButtonWithAPICall variant="contained" color="error" api={handleDecline} response={onResponse}>
                      {t("Từ chối")}
                    </ButtonWithAPICall>
                  </div>
                </div>
              </React.Fragment>
            )}
            <hr style={{ margin: "0 0 20px" }} />
            <div align="left" style={{ marginBottom: 0 }}>
              <b>{t("Thông tin hóa đơn")}</b>:
            </div>
            <div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "6.5fr 3.5fr",
                }}
              >
                <div align="center">
                  <div style={{ fontWeight: "bold" }}>HÓA ĐƠN GIÁ TRỊ GIA TĂNG</div>
                  <div>
                    <i>Ngày lập: {moment(data?.date).format("DD/MM/YYYY")}</i>
                  </div>
                </div>
                <div align="center">
                  <table>
                    <tbody>
                      <tr>
                        <td>
                          <b>Mẫu số:</b>
                        </td>
                        <td>{data?.form}</td>
                      </tr>
                      <tr>
                        <td>
                          <b>Ký hiệu:</b>
                        </td>
                        <td>{data?.serial}</td>
                      </tr>
                      <tr>
                        <td>
                          <b>Số:</b>
                        </td>
                        <td style={{ color: "red" }}>{data?.code}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <table style={{ margin: "30px 0 10px" }}>
                <tbody align="left">
                  <tr>
                    <td width="200">Đơn vị bán:</td>
                    <td colSpan={3}>
                      <b>{data?.provider_name}</b>
                    </td>
                  </tr>
                  <tr>
                    <td width="200">Địa chỉ:</td>
                    <td colSpan={3}>{data?.provider_address}</td>
                  </tr>
                  <tr>
                    <td width="200">Mã số thuế:</td>
                    <td width="300">
                      <b>{data?.provider_tax}</b>
                    </td>
                    <td width="300">Điện thoại: </td>
                    <td width="300">Mail: </td>
                  </tr>
                  <tr>
                    <td width="200">Đơn vị mua:</td>
                    <td colSpan={3}>
                      <b>{data?.customer_name}</b>
                    </td>
                  </tr>
                  <tr>
                    <td width="200">Địa chỉ:</td>
                    <td colSpan={3}>{data?.customer_address}</td>
                  </tr>
                  <tr>
                    <td width="200">Mã số thuế:</td>
                    <td width="300">
                      <b>{data?.customer_tax}</b>
                    </td>
                    <td width="300">Điện thoại: </td>
                    <td width="300">Mail: </td>
                  </tr>
                  <tr>
                    <td width="200">Hình thức TT:</td>
                    <td width="300" colSpan={3}></td>
                  </tr>
                </tbody>
              </table>

              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>STT</TableCell>
                      <TableCell>Hình thức</TableCell>
                      <TableCell>Hàng hóa</TableCell>
                      <TableCell>Mã HH</TableCell>
                      <TableCell>ĐVT</TableCell>
                      <TableCell>Số lượng</TableCell>
                      <TableCell>Đơn giá</TableCell>
                      <TableCell>% Chiết khẩu</TableCell>
                      <TableCell>Tiền CK</TableCell>
                      <TableCell>Thành tiền</TableCell>
                      <TableCell>Thuế suất</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data?.products &&
                      JSON.parse(JSON.parse(data.products)).map((item, index) => (
                        <TableRow key={index}>
                          <TableCell>{item.no}</TableCell>
                          <TableCell></TableCell>
                          <TableCell>{item.product}</TableCell>
                          <TableCell></TableCell>
                          <TableCell>{item.unit}</TableCell>
                          <TableCell>{item.quantity?.toLocaleString()}</TableCell>
                          <TableCell>{Math.round(item?.price)?.toLocaleString()}</TableCell>
                          <TableCell></TableCell>
                          <TableCell></TableCell>
                          <TableCell align="right">{Math.round(item?.total)?.toLocaleString()}</TableCell>
                          <TableCell>{item.vat_rate}</TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <div align="right">
                <table>
                  <tbody align="right">
                    <tr>
                      <td>
                        <b>Cộng tiền hàng:</b>
                      </td>
                      <td width="250" style={{ paddingRight: 15 }}>
                        {data?.amount && Math.round(data.amount).toLocaleString()}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <b>Cộng tiền thuế GTGT:</b>
                      </td>
                      <td width="250" style={{ paddingRight: 15 }}>
                        {data?.vat && Math.round(data.vat).toLocaleString()}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <b>Tổng cộng tiền thanh toán:</b>
                      </td>
                      <td width="250" style={{ paddingRight: 15 }}>
                        {data?.total && Math.round(data.total).toLocaleString()}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div align="left">
                <b>Bằng chữ: {data?.in_word}</b>
              </div>
            </div>
          </div>
          <div hidden={tab !== 3}>
            <EditPI
              initialData={data}
              onEditResponse={onEditResponse}
              onDeleteResponse={(res) => {
                onEditResponse(res);
                setTab(2);
              }}
            />
          </div>
        </div>
        <iframe title="pdf" typeof="pdf" hidden={tab !== 1} height="1000px" src={tab === 1 && toHttpsURL(data?.pdf) + "?timestamp=" + Date.now().toString()} />
      </Dialog>
    );
  return "";
});

export default InvoiceXMLReader;
